
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import IndexGB from "./pages/IndexGB";
import Confirmation from "./pages/Confirmation";
import IndexFr from "./pages/IndexFr";
import ConfirmationFr from "./pages/ConfirmationFr";
import NotFound from "./pages/NotFound";
import LandingPage from "./pages/LandingPage";
import OffersPage from "./pages/OffersPage";

const queryClient = new QueryClient();

// Helper component to check URL parameter and redirect if needed
const IndexRedirect = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const cParam = urlParams.get('c');
  
  if (cParam === 'Fr') {
    return <Navigate to="/fr" replace />;
  }
  
  return <IndexGB />;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/opt-out" element={<IndexRedirect />} />
          <Route path="/offers" element={<OffersPage />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/fr" element={<IndexFr />} />
          <Route path="/confirmation-fr" element={<ConfirmationFr />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
